/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */



(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  /******** Envision - comment out placeholder code, leaving it in for future reference

  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container: ' + container);
      console.log('Variant: ' + variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart: ' + cart);
      // ... update an app or a custom shipping caluclator
    }
  });

  // Debounced scroll listeners.  Up and down only fire on directions changes
  // These events are useful for creating sticky headers and footers.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  ********/

  // Envision - when variant is changed, update hidden _presale property input, Made to Order property input depending on variant inventory quantity.
  document.addEventListener("theme:variant:change", function (event) {
    //console.log('event variant change')
    var variant = event.detail.variant;
    //console.log('variant ', variant)
    var container = event.target;
    const color = variant?.option1;
    const feather_type = variant?.option2;
   
    //validateFeatherType(color);
    //validateSize(feather_type);

    if (variant && container) {
      var presale_property_input = container.querySelector(
        '[name^="properties[_presale]"]'
      );
      var madetoorder_input = container.querySelector(
        '[name^="properties[Made to Order]"]'
      );
      var preorder_message =
        "This product is being made to order and requires an additional 1 - 2 weeks lead time. Once complete, your order will ship in full via your selected shipping service.";

      var buttonState = null;
      var statesEl = container.querySelector("[data-variant-button-states]");
      if (statesEl) {
        try {
          var states = JSON.parse(statesEl.textContent);
          buttonState = states[variant.id.toString()];
        } catch (e) {}
      }
      if (!buttonState) {
        var iq = variant.inventory_quantity;
        if ((iq === 0 || iq === "0") && variant.inventory_policy === "continue") {
          buttonState = "made_to_order";
        } else {
          buttonState = iq > 0 ? "add_to_cart" : "waitlist";
        }
      }
      var isMadeToOrder = buttonState === "made_to_order";
      var isEmbroidery = !!container.querySelector('[name^="properties[embroidery]"]:not([disabled])');

      if (presale_property_input) {
        presale_property_input.value = isMadeToOrder ? "true" : "false";

        // Asegurar propiedad Made to Order (solo si no es embroidery)
        if (isMadeToOrder && !isEmbroidery) {
          if (madetoorder_input) {
            madetoorder_input.value = preorder_message;
          } else {
            var newInput = document.createElement("input");
            newInput.type = "hidden";
            newInput.name = "properties[Made to Order]";
            newInput.value = preorder_message;
            presale_property_input.parentNode.insertBefore(newInput, presale_property_input.nextSibling);
          }
        } else if (madetoorder_input) {
          madetoorder_input.remove();
        }

        presale_property_input.dispatchEvent(new Event("change"));
      }
    }
  });
})();



/*
function validateFeatherType(color = null){
  const product__variants_hidden = document.getElementById('product__variants_hidden');
  const variants_json = product__variants_hidden.value;
  const variants = JSON.parse(variants_json);
  const feather_type_available = [];
  const size_available = [];
  const swatchers = document.querySelectorAll('[data-swatch-filename]');
  //activamos todos los elementos
  for (const swatcher of swatchers) { 
    swatcher.style.display = 'block';
  }

  for (const variant of variants) {
    if(variant.option1 == color){
      feather_type_available.push(variant.option2);
      size_available.push(variant.option3);
    }
  }

  const unique_feather_type_available = [...new Set(feather_type_available)];

  //ocultamos los que no estan en el color
  for (const swatcher of swatchers) {
    const swatcher_filename = swatcher.getAttribute('data-swatch-filename');
    const swatcher_filename_santized = capitalize(swatcher_filename.replace('.png', ''));
    
    if (!unique_feather_type_available.includes(swatcher_filename_santized)) {
      swatcher.style.display = 'none';
    }
  }
}
*/
/*
function validateSize(feather_type = null){
  const product__variants_hidden = document.getElementById('product__variants_hidden');
  const variants_json = product__variants_hidden.value;
  const variants = JSON.parse(variants_json);
  const size_available = [];
  const swatchers = document.querySelectorAll('[data-size]');
  //activamos todos los elementos
  for (const swatcher of  swatchers) {
    console.log('swatcher', swatcher);
    swatcher.style.display = 'inline-block';
  }

  for (const variant of variants) {
    if(variant.option2 == feather_type){
      size_available.push(variant.option3);
    }
  }

  const unique_size_available = [...new Set(size_available)];

  //ocultamos los que no estan en el color
  for (const swatcher of swatchers) {
    const swatcher_size_name = swatcher.getAttribute('data-size');
    console.log('unique_size_available', unique_size_available)
    console.log('swatcher_size_name ', swatcher_size_name);
    
    if (!unique_size_available.includes(swatcher_size_name)) {
      swatcher.style.display = 'none';
    }
  }

}
*/
function capitalize(s)
{
    return s[0].toUpperCase() + s.slice(1);
}

jQuery(function ($) {
  window.onload = update_madetoorder_status;
  function update_madetoorder_status() {
    if ($(".product-data-group").length) {
      if ($(".product-data-group input").length) {
        $(".product-data-group input").each(function (index, obj) {
          var handle = $(obj).attr("data-product-handle");
          var real_qty = $(obj).val();
          var selector = "form[data-product-handle='" + handle + "']";
          if ($(selector).length) {
            $(selector + " input#inventory_quantity").attr("data", real_qty);
            var available = $(selector + " input#available").attr("data");
            var preorder_threshold = $(
              selector + " input#preorder_threshold"
            ).attr("data");
            var inventory_policy = $(selector + " input#inventory_policy").attr(
              "data"
            );
            var isEmbroideryForm = $(selector + ' input[name^="properties[embroidery]"]:not([disabled])').length > 0;
            if (
              !isEmbroideryForm &&
              available == "true" &&
              parseInt(real_qty) === 0 &&
              inventory_policy == "continue"
            ) {
              var preorder_message =
                "This product is being made to order and requires an additional 1 - 2 weeks lead time. Once complete, your order will ship in full via your selected shipping service.";
              if ($(selector + " input#preorder-property").length) {
                $(selector + " input#preorder-property").attr(
                  "name",
                  "properties[Made to Order]"
                );
                $(selector + " input#preorder-property").val(preorder_message);
              } else {
                var elem =
                  '<input id="preorder-property" type="hidden" name="properties[Made to Order]" value="' +
                  preorder_message +
                  '">';
                $(selector).append(elem);
              }
              $(selector + " button span.data-add-to-cart-text").text(
                "Made To Order"
              );
            }
            var presaleInput = $(selector).find('[name^="properties[_presale]"]');
            if(presaleInput.length){
              presaleInput.val(parseInt(real_qty) === 0 ? "true" : "false");
            }
            
          }
        });
      }
    }
  }
  $(".page.current").on("DOMSubtreeModified", function (e) {
    alert();
  });
  /*
    $(".collection__products.filtered").on('click', '.collection-add-to-cart', function(e){
      e.preventDefault();
      
      var handle = $(this).attr('data-product-handle');
      var quantity_selector = "input[data-product-handle='" + handle + "']";
      var real_quantity = $(quantity_selector).val();
      var available = $(this).closest('form').find("#available").attr("data");
      var preorder_threshold = $(this).closest('form').find("#preorder_threshold").attr("data");
      var inventory_policy = $(this).closest('form').find("#inventory_policy").attr("data");
      console.log("available", available);
      console.log("real_quantity", real_quantity);
      console.log("preorder_threshold", preorder_threshold);
      console.log("inventory_policy", inventory_policy);
      if( available == "true" && real_quantity <= preorder_threshold && inventory_policy == "CONTINUE"){
      	$(this).closest('form').find("#preorder-property").attr('name', 'properties[Made to Order]').val("This product is being made to order and requires additional time. Once complete, your order will ship in full via your selected shipping service.");
      	//$(this).find('span').text("Made to order");
      }
      if( real_quantity <= preorder_threshold ){
      	$(this).closest('form').find("#_presale").attr('name', 'properties[_presale]').val("true");
      }else{
      	$(this).closest('form').find("#_presale").attr('name', 'properties[_presale]').val("false");
      }
//       alert($(this).closest('form').find("#preorder-property").val());
      $(this).closest('form').submit();
    });
*/
});

// Product Options Quantity Selector Functionality
(function() {
  'use strict';
  // Function to get main product quantity
  function getMainProductQuantity() {
    const mainQuantityInput = document.querySelector('[data-quantity-input]');
    return mainQuantityInput ? parseInt(mainQuantityInput.value) || 1 : 1;
  }

  // Function to update addon quantity limits based on main product quantity
  function updateAddonQuantityLimits() {
    const mainQuantity = getMainProductQuantity();
    const addonQuantityInputs = document.querySelectorAll('.product-option__quantity-input');
    
    addonQuantityInputs.forEach(function(input) {
      const currentValue = parseInt(input.value) || 1;
      const optionId = input.getAttribute('data-option-id');
      const quantityWrapper = input.closest('.product-option__quantity-wrapper');
      const checkbox = document.querySelector('.product-option__checkbox[data-option-id="' + optionId + '"]');
      
      // Update max attribute
      input.setAttribute('max', mainQuantity);
      
      // Show/hide quantity selector based on main product quantity
      if (mainQuantity <= 1) {
        // Hide quantity selector when main product quantity is 1 or less
        if (quantityWrapper && checkbox && checkbox.checked) {
          quantityWrapper.style.display = 'none';
        }
        // Set addon quantity to 1 when main product is 1
        input.value = 1;
        const hiddenQuantityInput = document.querySelector('#product-option-quantity-hidden--' + optionId);
        if (hiddenQuantityInput && checkbox && checkbox.checked) {
          hiddenQuantityInput.value = '1';
          // NO se setea name: la cantidad se inyecta en la línea principal desde el
          // flujo AJAX (mainAddToCart). Un name aquí lo colaría por Shop Pay.
        }
        updateRepeaterFields(optionId, 1);
      } else {
        // Show quantity selector when main product quantity is greater than 1
        if (quantityWrapper && checkbox && checkbox.checked) {
          quantityWrapper.style.display = 'block';
        }
        
        // If current value exceeds new max, adjust it
        if (currentValue > mainQuantity) {
          input.value = mainQuantity;
          
          // Update hidden field as well
          const hiddenQuantityInput = document.querySelector('#product-option-quantity-hidden--' + optionId);
          if (hiddenQuantityInput && checkbox && checkbox.checked) {
            hiddenQuantityInput.value = mainQuantity;
            // NO se setea name (se inyecta en mainAddToCart).
          }
          
          // Update repeater fields based on new quantity
          updateRepeaterFields(optionId, mainQuantity);
        }
      }
    });
  }

  // Initialize product options quantity selectors
  function initProductOptionsQuantity() {
    // Handle checkbox changes to show/hide quantity selector
    document.addEventListener('change', function(e) {
      if (e.target.classList.contains('product-option__checkbox')) {
        const optionId = e.target.getAttribute('data-option-id');
        const quantityWrapper = document.querySelector('.product-option__quantity-wrapper[data-option-id="' + optionId + '"]') ||
                               e.target.closest('.product-option__wrapper').querySelector('.product-option__quantity-wrapper');
        
        if (quantityWrapper) {
          const quantityInput = quantityWrapper.querySelector('.product-option__quantity-input');
          const hiddenQuantityInput = quantityWrapper.querySelector('#product-option-quantity-hidden--' + optionId);
          
          if (e.target.checked) {
            const mainQuantity = getMainProductQuantity();
            // Only show quantity selector if main product quantity > 1
            if (mainQuantity > 1) {
              quantityWrapper.style.display = 'block';
            } else {
              quantityWrapper.style.display = 'none';
            }
            // Update addon limits when showing
            updateAddonQuantityLimits();
            // Update hidden field with current quantity and enable it
            if (hiddenQuantityInput && quantityInput) {
              hiddenQuantityInput.value = quantityInput.value;
              // NO se setea name (se inyecta en mainAddToCart).
            }
          } else {
            quantityWrapper.style.display = 'none';
            // Reset quantity to 1 when unchecked
            if (quantityInput) {
              quantityInput.value = 1;
            }
            // Remove name attribute to prevent empty value from being submitted
            if (hiddenQuantityInput) {
              hiddenQuantityInput.value = '';
              hiddenQuantityInput.removeAttribute('name');
            }
          }
        }
      }
    });

    // Listen for changes in main product quantity
    document.addEventListener('change', function(e) {
      if (e.target.matches('[data-quantity-input]')) {
        updateAddonQuantityLimits();
      }
    });

    // Listen for main product quantity changes via buttons
    document.addEventListener('click', function(e) {
      if (e.target.matches('.js-qty__adjust')) {
        // Use setTimeout to ensure the quantity input value is updated first
        setTimeout(updateAddonQuantityLimits, 10);
      }
    });

    // Handle quantity button clicks
    document.addEventListener('click', function(e) {
      if (e.target.classList.contains('product-option__quantity-btn')) {
        e.preventDefault();
        const optionId = e.target.getAttribute('data-option-id');
        const quantityInput = document.querySelector('#product-option-quantity--' + optionId);
        
        if (quantityInput) {
          let currentValue = parseInt(quantityInput.value) || 1;
          const min = parseInt(quantityInput.getAttribute('min')) || 1;
          // Get dynamic max based on main product quantity
          const mainQuantity = getMainProductQuantity();
          const max = Math.min(parseInt(quantityInput.getAttribute('max')) || 99, mainQuantity);
          
          if (e.target.classList.contains('product-option__quantity-btn--plus')) {
            if (currentValue < max) {
              quantityInput.value = currentValue + 1;
            }
          } else if (e.target.classList.contains('product-option__quantity-btn--minus')) {
            if (currentValue > min) {
              quantityInput.value = currentValue - 1;
            }
          }
          
          // Update hidden field with new quantity
          const hiddenQuantityInput = document.querySelector('#product-option-quantity-hidden--' + optionId);
          if (hiddenQuantityInput) {
            hiddenQuantityInput.value = quantityInput.value;
            // NO se setea name (se inyecta en mainAddToCart).
          }
          
          // Update repeater fields based on new quantity
          updateRepeaterFields(optionId, parseInt(quantityInput.value));
          
          // Trigger change event for any listeners
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    // Handle direct input changes
    document.addEventListener('input', function(e) {
      if (e.target.classList.contains('product-option__quantity-input')) {
        const min = parseInt(e.target.getAttribute('min')) || 1;
        // Get dynamic max based on main product quantity
        const mainQuantity = getMainProductQuantity();
        const max = Math.min(parseInt(e.target.getAttribute('max')) || 99, mainQuantity);
        let value = parseInt(e.target.value) || min;
        
        // Ensure value is within bounds
        if (value < min) {
          e.target.value = min;
        } else if (value > max) {
          e.target.value = max;
        }
        
        // Update hidden field with new quantity
        const optionId = e.target.getAttribute('data-option-id');
        const hiddenQuantityInput = document.querySelector('#product-option-quantity-hidden--' + optionId);
        if (hiddenQuantityInput) {
          hiddenQuantityInput.value = e.target.value;
          // NO se setea name (se inyecta en mainAddToCart).
        }
        
        // Update repeater fields based on new quantity
        updateRepeaterFields(optionId, parseInt(e.target.value));
      }
    });
  }

  // Function to get product option quantity for integration with existing cart system
  window.getProductOptionQuantity = function(optionId) {
    const checkbox = document.querySelector('.product-option__checkbox[data-option-id="' + optionId + '"]');
    const quantityInput = document.querySelector('#product-option-quantity--' + optionId);
    
    // Only return quantity if checkbox is checked
    if (checkbox && checkbox.checked && quantityInput) {
      const mainQuantity = getMainProductQuantity();
      
      // If main product quantity is 1, return 1 (selector is hidden but addon should have quantity 1)
      if (mainQuantity <= 1) {
        return 1;
      }
      
      // If main product quantity > 1, return the selected quantity (selector is visible)
      return parseInt(quantityInput.value) || 1;
    }
    return 0; // Return 0 if not selected, so it won't be added to cart
  };

  // Function to get modified product title with quantity
  window.getProductOptionTitleWithQuantity = function(optionId) {
    const checkbox = document.querySelector('.product-option__checkbox[data-option-id="' + optionId + '"]');
    const quantityInput = document.querySelector('#product-option-quantity--' + optionId);
    const originalTitleInput = document.querySelector('#product-option-title-hidden--' + optionId);
    
    if (checkbox && checkbox.checked && quantityInput && originalTitleInput) {
      const quantity = parseInt(quantityInput.value) || 1;
      const originalTitle = originalTitleInput.value;
      
      if (quantity > 1) {
        return originalTitle + ': ' + quantity;
      } else {
        return originalTitle;
      }
    }
    return null;
  };

  // Function to add quantity to cart product option titles and hide quantity properties
  window.updateCartDrawerQuantityDisplay = function() {
    // Function to process cart items
    function processCartItems() {
      // Look for both rebuy cart items and regular cart product options
      const cartItems = document.querySelectorAll('.rebuy-cart__flyout-item, .cart-product-option');
      
      cartItems.forEach(function(item) {
        // Find the title element - could be in different structures
        let titleElement = item.querySelector('.cart-product-option__title');
        if (!titleElement) {
          titleElement = item.querySelector('.cart-product-option__name');
        }
        
        // Find quantity property elements - try different selectors
        let quantityProperties = item.querySelectorAll('.rebuy-cart__flyout-item-property');
        if (quantityProperties.length === 0) {
          quantityProperties = item.querySelectorAll('.cart-product-option-details .property');
        }
        
        quantityProperties.forEach(function(propertyRow) {
          let propertyKeyElement = propertyRow.querySelector('[class*="property-key"]');
          let propertyValueElement = propertyRow.querySelector('[class*="property-value"]');
          
          // Try alternative selectors if not found
          if (!propertyKeyElement) {
            propertyKeyElement = propertyRow.querySelector('.property-name');
          }
          if (!propertyValueElement) {
            propertyValueElement = propertyRow.querySelector('.property-value');
          }
          
          if (propertyKeyElement && propertyValueElement) {
            const propertyKey = propertyKeyElement.textContent.trim().toLowerCase();
            const propertyValue = propertyValueElement.textContent.trim();
            
            // Check if this is a quantity property
            if (propertyKey.includes('quantity')) {
              // Hide the property row
              propertyRow.style.display = 'none';
              
              // Add quantity to the title element if it exists
              if (titleElement && propertyValue) {
                const currentTitle = titleElement.textContent.trim();
                
                // Only add quantity if it's not already there
                if (!currentTitle.includes(' ' + propertyValue) && !currentTitle.includes(': ' + propertyValue)) {
                  // Clean the title first (remove any existing quantity)
                  let cleanTitle = currentTitle;
                  cleanTitle = cleanTitle.replace(/\s+\d+$/, ''); // Remove numbers at the end
                  cleanTitle = cleanTitle.replace(/:\s*\d+$/, ''); // Remove ": number" at the end
                  
                  // Add the quantity to the title
                  titleElement.textContent = cleanTitle + ' ' + propertyValue;
                }
              }
            }
          }
        });
      });
      
      // Also try to find and update cart product options directly
      const directCartOptions = document.querySelectorAll('.cart-product-option');
      directCartOptions.forEach(function(option) {
        const nameElement = option.querySelector('.cart-product-option__name');
        if (nameElement && nameElement.textContent.includes('Gift Wrap')) {
          console.log('Found Gift Wrap element:', nameElement);
          // Try to find quantity in the option's properties
          const properties = option.querySelectorAll('.cart-product-option-details .property');
          properties.forEach(function(prop) {
            const text = prop.textContent.toLowerCase();
            if (text.includes('quantity')) {
              console.log('Found quantity property:', prop.textContent);
            }
          });
        }
      });
    }
    
    // Run immediately
    processCartItems();
    
    // Also run after a short delay to catch any late updates
    setTimeout(processCartItems, 100);
    setTimeout(processCartItems, 300);
    setTimeout(processCartItems, 800);
  };

  // Function to reset all product option quantities (called after successful cart add)
  window.resetProductOptionQuantities = function() {
    const quantityInputs = document.querySelectorAll('.product-option__quantity-input');
    quantityInputs.forEach(function(input) {
      input.value = 1;
    });
    const quantityWrappers = document.querySelectorAll('.product-option__quantity-wrapper');
    quantityWrappers.forEach(function(wrapper) {
      wrapper.style.display = 'none';
    });
    // Also reset hidden quantity fields and remove name attribute
    const hiddenQuantityInputs = document.querySelectorAll('input[id^="product-option-quantity-hidden--"]');
    hiddenQuantityInputs.forEach(function(input) {
      input.value = '';
      input.removeAttribute('name');
    });
    // Reset repeater fields to single item
    const repeaterContainers = document.querySelectorAll('[data-repeater-container]');
    repeaterContainers.forEach(function(container) {
      const optionId = container.getAttribute('data-repeater-container');
      updateRepeaterFields(optionId, 1);
    });
  };

  // Function to update repeater fields based on quantity
  function updateRepeaterFields(optionId, quantity) {
    const repeaterContainer = document.querySelector('[data-repeater-container="' + optionId + '"]');
    if (!repeaterContainer) return;

    const currentItems = repeaterContainer.querySelectorAll('.product-option__details-item');
    const currentCount = currentItems.length;
    
    // Get base info from first item
    const firstItem = currentItems[0];
    if (!firstItem) return;
    
    const firstTextarea = firstItem.querySelector('.product-option__textarea');
    const baseName = firstTextarea.getAttribute('data-base-name');
    const placeholder = firstTextarea.getAttribute('placeholder');
    const maxLength = firstTextarea.getAttribute('maxlength');
    const required = firstTextarea.hasAttribute('required');
    
    
    if (quantity > currentCount) {
      // Add more fields
      for (let i = currentCount + 1; i <= quantity; i++) {
        const newItem = document.createElement('div');
        newItem.className = 'product-option__details-item';
        newItem.setAttribute('data-item-index', i);
        
        const textarea = document.createElement('textarea');
        textarea.id = baseName + '-' + i;
        textarea.className = 'product-option__textarea';
        textarea.name = baseName + '-' + i;
        textarea.setAttribute('data-base-name', baseName);
        textarea.setAttribute('data-option-id', optionId);
        textarea.setAttribute('data-item-index', i);
        textarea.setAttribute('placeholder', placeholder);
        if (maxLength) textarea.setAttribute('maxlength', maxLength);
        if (required) textarea.setAttribute('required', 'required');
        
        newItem.appendChild(textarea);
        repeaterContainer.appendChild(newItem);
      }
    } else if (quantity < currentCount) {
      // Remove excess fields
      for (let i = currentCount; i > quantity; i--) {
        const itemToRemove = repeaterContainer.querySelector('[data-item-index="' + i + '"]');
        if (itemToRemove) {
          itemToRemove.remove();
        }
      }
    }
    
    repeaterContainer.setAttribute('data-single-item', quantity === 1 ? 'true' : 'false');
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initProductOptionsQuantity();
      // Set initial limits based on main product quantity
      updateAddonQuantityLimits();
    });
  } else {
    initProductOptionsQuantity();
    // Set initial limits based on main product quantity
    updateAddonQuantityLimits();
  }
})();

// Integración suave con Product Personalizer (Zepto):
// Cuando el app termine su propio Add to Cart (embroidery + producto),
// escuchamos el evento pplrAddToCartCompleted, asignamos un _UUID a la
// línea principal añadida por Zepto y luego añadimos SOLO nuestros
// add-ons (Gift Wrap, Box, etc.) mediante window.addProductOptionsOnly(uuid).
(function() {
  'use strict';

  if (typeof window === 'undefined') return;

  function generateUUID() {
    // Reutilizar uuid() global si existe
    if (typeof window.uuid === 'function') {
      return window.uuid();
    }
    // Fallback simple
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  try {
    window.addEventListener('pplrAddToCartCompleted', function(e) {
      try {
        // 1) Leer carrito actualizado: Zepto ya ha añadido su línea
        fetch('/cart.js')
          .then(function(res) { return res.json(); })
          .then(function(cart) {
            if (!cart || !cart.items || !cart.items.length) {
              console.warn('[PP] Cart vacío tras pplrAddToCartCompleted');
              return null;
            }

            // Suponemos que la última línea añadida es la de Zepto
            var lastIndex = cart.items.length - 1;
            var lastItem = cart.items[lastIndex];
            if (!lastItem) {
              return null;
            }

            var uuid = generateUUID();

            // 2) Asignar _UUID al ítem principal de Zepto vía /cart/change.js.
            //    Además inyectar aquí el aviso "embroidery" (el input del theme está
            //    siempre disabled para que no lo cuele Shop Pay), de modo que el aviso
            //    solo llegue a la línea cuando Zepto realmente corrió.
            var extraProps = { _UUID: uuid };
            var embroideryInput = document.getElementById('embroidery-property');
            var personalizerCheckbox = document.querySelector('#product-option--personalizer');
            if (embroideryInput && personalizerCheckbox && personalizerCheckbox.checked && embroideryInput.value) {
              extraProps.embroidery = embroideryInput.value;
            }

            var changePayload = {
              line: lastIndex + 1, // API usa 1-based index
              properties: Object.assign({}, lastItem.properties || {}, extraProps)
            };

            return fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json; charset=UTF-8'
              },
              body: JSON.stringify(changePayload)
            }).then(function() {
              return uuid;
            });
          })
          .then(function(uuid) {
            if (!uuid) {
              // No UUID asignado, salir sin añadir add-ons
              return;
            }

            // 3) Añadir SOLO nuestros add-ons vinculados a ese _UUID
            if (typeof window.addProductOptionsOnly === 'function') {
              window.addProductOptionsOnly(uuid);
            } else {
              console.warn('[PP] pplrAddToCartCompleted: addProductOptionsOnly no está definido');
            }
          })
          .catch(function(err) {
            console.error('[PP] Error en flujo pplrAddToCartCompleted + addProductOptionsOnly', err);
          });
      } catch (innerErr) {
        console.error('[PP] Error inicial al manejar pplrAddToCartCompleted', innerErr);
      }
    });
  } catch (err) {
    console.error('[PP] Error registrando listener de pplrAddToCartCompleted', err);
  }
})();

// Sync embroidery property input with embroidery checkbox
(function () {
  function syncEmbroideryProperty() {
    var embroideryProperty = document.getElementById('embroidery-property');
    if (!embroideryProperty) return;

    var embroideryCheckbox =
      document.querySelector('#product-option--personalizer') ||
      document.querySelector('.product-option__checkbox');
    if (!embroideryCheckbox) return;

    function toggle(checked) {
      // El aviso #embroidery-property se mantiene SIEMPRE disabled para que no lo
      // serialice el checkout dinámico / Shop Pay (que se salta /cart/add.js y dejaría
      // el aviso sin datos de Zepto ni cargo). Se inyecta solo en la ruta AJAX/Zepto.
      embroideryProperty.disabled = true;
      var madeToOrderInput = document.querySelector('[name="properties[Made to Order]"]');
      if (madeToOrderInput) {
        madeToOrderInput.disabled = checked;
      }
    }

    toggle(embroideryCheckbox.checked);
    embroideryCheckbox.addEventListener('change', function () {
      toggle(this.checked);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncEmbroideryProperty);
  } else {
    syncEmbroideryProperty();
  }
})();

// ---------------------------------------------------------------------------
// Reconciliador de add-ons huérfanos
// Si en la línea principal quedaron properties de un add-on (embroidery / box
// engraving / gift wrap) pero su línea de producto/cargo YA NO está en el carrito
// (p.ej. el usuario eliminó el add-on en el drawer de Rebuy), las barre vía
// /cart/change.js para que no llegue a la orden un add-on "fantasma" sin cargo.
// Solo BORRA; nunca agrega. No toca líneas hijas (las que tienen _ForUUID).
// ---------------------------------------------------------------------------
(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof window.fetch !== 'function') return;

  var reconciling = false;
  var debounceTimer = null;

  function stripKeys(props, keysToStrip) {
    var out = {};
    Object.keys(props || {}).forEach(function (k) {
      if (keysToStrip.indexOf(k) === -1) {
        out[k] = props[k];
      }
    });
    return out;
  }

  function reconcile() {
    if (reconciling) return;
    reconciling = true;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return null;

        // Índices de lo presente en el carrito
        var variantIds = {};
        var forUuids = {};
        cart.items.forEach(function (it) {
          if (it.variant_id != null) variantIds[String(it.variant_id)] = true;
          var p = it.properties || {};
          if (p._ForUUID) forUuids[p._ForUUID] = true;
        });

        var updates = [];

        cart.items.forEach(function (it) {
          var p = it.properties || {};
          var isChild = !!p._ForUUID; // las líneas hijas (add-on) no se tocan
          var strip = [];

          // Embroidery (Zepto): la línea principal referencia el cargo por
          // _pc_pricing_qty_split = "<variantId>-<qty>". Si esa variante no está → huérfano.
          if (!isChild && p._pc_pricing_qty_split) {
            var refVariant = String(p._pc_pricing_qty_split).split('-')[0];
            if (refVariant && !variantIds[refVariant]) {
              ['Text', 'Letter', 'Color', 'Preview', '_pplr_preview',
               '_pc_pricing_ref', '_pc_pricing_qty_split', 'embroidery'
              ].forEach(function (k) { if (k in p) strip.push(k); });
            }
          }

          // Box engraving: marcadores en la línea principal sin línea hija ligada.
          if (!isChild && (p._BoxEngravingMessageID || p['Box Engraving - Quantity'])) {
            var hasBoxChild = p._UUID ? !!forUuids[p._UUID] : false;
            if (!hasBoxChild) {
              ['_BoxEngravingMessageID', 'Box Engraving - Quantity', 'Engraving Message'
              ].forEach(function (k) { if (k in p) strip.push(k); });
            }
          }

          // Gift wrap: análogo.
          if (!isChild && (p._GiftWrapMessageID || p['Gift Wrap - Quantity'])) {
            var hasGiftChild = p._UUID ? !!forUuids[p._UUID] : false;
            if (!hasGiftChild) {
              ['_GiftWrapMessageID', 'Gift Wrap - Quantity', 'Gift Message'
              ].forEach(function (k) { if (k in p) strip.push(k); });
            }
          }

          if (strip.length) {
            updates.push({ id: it.key, properties: stripKeys(p, strip) });
          }
        });

        if (!updates.length) return null;

        // Aplicar secuencialmente para no pisar el carrito.
        return updates.reduce(function (chain, u) {
          return chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json;charset=UTF-8' },
              credentials: 'same-origin',
              body: JSON.stringify({ id: u.id, properties: u.properties })
            });
          });
        }, Promise.resolve());
      })
      .catch(function (err) {
        console.error('[addon-reconcile] error', err);
      })
      .then(function () { reconciling = false; });
  }

  function scheduleReconcile() {
    if (debounceTimer) clearTimeout(debounceTimer);
    // Debounce alto: deja que un add-to-cart legítimo termine (hijo + padre / Zepto)
    // antes de evaluar, para no barrer properties de un add en progreso.
    debounceTimer = setTimeout(reconcile, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleReconcile);
  } else {
    scheduleReconcile();
  }
  window.addEventListener('pageshow', scheduleReconcile);

  // Observar el drawer de Rebuy Smart Cart: cuando el usuario elimina un add-on ahí,
  // el flyout se re-renderiza → reconciliar. Rebuy puede montar tarde: reintentar.
  var attachTries = 0;
  var attachInterval = setInterval(function () {
    var flyout = document.querySelector('.rebuy-cart__flyout, .rebuy-cart');
    if (flyout && !flyout.__addonReconcileObserved) {
      flyout.__addonReconcileObserved = true;
      new MutationObserver(scheduleReconcile).observe(flyout, {
        childList: true,
        subtree: true
      });
    }
    if (++attachTries > 20) clearInterval(attachInterval);
  }, 1000);
})();

// ---------------------------------------------------------------------------
// Expiración automática de carrito (24h) — ticket helpdesk X10LY9
// Guarda un timestamp (ms epoch) en el atributo de carrito "cart_created_at"
// cuando el carrito pasa de vacío a tener items. En cada carga de página se
// compara ese timestamp contra la hora actual: si pasaron más de 24h, se
// vacía el carrito vía /cart/clear.js.
//
// Limitación conocida (comunicada al cliente en el análisis del ticket):
// esta evaluación solo corre cuando el navegador ejecuta este script, es
// decir en la próxima carga de página / click en "Checkout" del cliente.
// No es un proceso de servidor corriendo en segundo plano: Shopify no
// expone los carritos como un recurso consultable vía Admin API, y las
// Cart/Checkout Validation Functions no tienen acceso a la hora del
// servidor, por lo que no es posible expirar el carrito exactamente a las
// 24h si el cliente no interactúa con el sitio.
// ---------------------------------------------------------------------------
(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof window.fetch !== 'function') return;

  var CART_EXPIRY_MS = 24 * 60 * 60 * 1000;
  var CART_TIMESTAMP_ATTR = 'cart_created_at';
  var JSON_HEADERS = { 'Content-Type': 'application/json;charset=UTF-8' };

  var checking = false;
  var debounceTimer = null;

  function setCartTimestamp(value) {
    var attributes = {};
    attributes[CART_TIMESTAMP_ATTR] = value === '' ? '' : String(value);
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: JSON_HEADERS,
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attributes })
    });
  }

  function clearExpiredCart() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      headers: JSON_HEADERS,
      credentials: 'same-origin'
    })
      .then(function () {
        // /cart/clear.js vacía los line items pero NO borra los atributos del
        // carrito: hay que resetear el timestamp para el próximo ciclo, o el
        // carrito quedaría marcado como "expirado" apenas se agregue algo nuevo.
        return setCartTimestamp('');
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('theme:cart:expired'));
      });
  }

  function checkCartExpiration() {
    if (checking) return;
    checking = true;

    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart) return null;

        var createdAt = cart.attributes && cart.attributes[CART_TIMESTAMP_ATTR];

        if (!cart.item_count) {
          // Carrito vacío: limpiar timestamp residual para el próximo ciclo.
          if (createdAt) return setCartTimestamp('');
          return null;
        }

        if (!createdAt) {
          return setCartTimestamp(Date.now());
        }

        var ageMs = Date.now() - parseInt(createdAt, 10);
        if (ageMs > CART_EXPIRY_MS) {
          return clearExpiredCart();
        }

        return null;
      })
      .catch(function (err) {
        console.error('[cart-expiration] error', err);
      })
      .then(function () { checking = false; });
  }

  function scheduleCheck() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(checkCartExpiration, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleCheck);
  } else {
    scheduleCheck();
  }
  window.addEventListener('pageshow', scheduleCheck);
  document.addEventListener('theme:cart:change', scheduleCheck);

  // Red de seguridad app-agnóstica: Rebuy Smart Cart (drawer real de la tienda)
  // y el flujo de Product Personalizer/Zepto agregan al carrito con su propio
  // JS y NUNCA disparan "theme:cart:change" (confirmado revisando theme.dev.js
  // y custom.js). Sin esto, si el cliente agrega algo por esas vías y se queda
  // en la misma pestaña sin navegar, el timestamp no se fijaría hasta la
  // siguiente carga de página. Este poll cierra ese hueco sin depender de
  // conocer los eventos internos de cada app. La ventana es de 24h, así que
  // no hace falta granularidad fina: 5 min es suficiente y reduce la carga.
  var POLL_INTERVAL_MS = 5 * 60 * 1000;
  var pollTimer = null;
  function startPolling() {
    if (pollTimer) return;
    pollTimer = setInterval(scheduleCheck, POLL_INTERVAL_MS);
  }
  function stopPolling() {
    if (!pollTimer) return;
    clearInterval(pollTimer);
    pollTimer = null;
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      scheduleCheck();
      startPolling();
    } else {
      stopPolling();
    }
  });
  if (document.visibilityState === 'visible') startPolling();

  // Refuerzo: al hacer click en "Checkout" desde la página de carrito,
  // re-validar antes de dejar avanzar. No cubre los botones de express
  // checkout (Shop Pay / Apple Pay / Google Pay) ni el flyout de Rebuy,
  // que no pasan por este formulario — limitación ya comunicada al cliente.
  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('.checkout__button');
    if (!button) return;

    var form = button.closest('form');
    if (!form) return;

    e.preventDefault();

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var createdAt = cart && cart.attributes && cart.attributes[CART_TIMESTAMP_ATTR];
        var expired = createdAt && (Date.now() - parseInt(createdAt, 10)) > CART_EXPIRY_MS;

        if (expired) {
          return clearExpiredCart().then(function () {
            window.location.reload();
          });
        }

        HTMLFormElement.prototype.submit.call(form);
      })
      .catch(function (err) {
        console.error('[cart-expiration] checkout guard error', err);
        HTMLFormElement.prototype.submit.call(form);
      });
  });
})();

// ---------------------------------------------------------------------------
// Mensaje de urgencia de expiración de carrito, dentro del drawer de Rebuy
// Smart Cart. Pedido de la clienta: comunicar en el propio carrito que su
// contenido expira, para generar urgencia. El texto es editable por el
// merchant en Theme Settings > Custom - Content Management > Cart
// (settings.cart_expiration_notice_text), leído aquí vía el data bridge
// sitewide en layout/theme.liquid (el drawer de Rebuy puede abrirse desde
// cualquier página, no solo /cart, así que no podemos depender de
// section.settings).
// ---------------------------------------------------------------------------
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var dataEl = document.getElementById('cart-expiration-notice-data');
  if (!dataEl) return;

  var enabled = dataEl.getAttribute('data-enabled') === 'true';
  var text = dataEl.getAttribute('data-text');
  if (!enabled || !text) return;

  function insertNotice(flyout) {
    if (flyout.querySelector('.rebuy-cart__expiration-notice')) return;
    var notice = document.createElement('p');
    notice.className = 'rebuy-cart__expiration-notice';
    notice.textContent = text;
    flyout.insertBefore(notice, flyout.firstChild);
  }

  function checkFlyouts() {
    document.querySelectorAll('.rebuy-cart__flyout, .rebuy-cart').forEach(insertNotice);
  }

  checkFlyouts();

  var attachTries = 0;
  var attachInterval = setInterval(function () {
    var flyout = document.querySelector('.rebuy-cart__flyout, .rebuy-cart');
    if (flyout) {
      checkFlyouts();
      if (!flyout.__expirationNoticeObserved) {
        flyout.__expirationNoticeObserved = true;
        new MutationObserver(checkFlyouts).observe(flyout, {
          childList: true,
          subtree: true
        });
      }
    }
    if (++attachTries > 20) clearInterval(attachInterval);
  }, 1000);
})();

// ---------------------------------------------------------------------------
// Cascada bidireccional: cargo de personalización ($25 engraving, llaveros)
// El checkbox "Personalize Your Keychain" (product-options.liquid) agrega,
// vía el flujo genérico de add-ons del theme, una línea separada para el
// producto de cargo configurado en section.settings.personalization_charge_product,
// marcada con properties._PersonalizationCharge = "true" y enlazada a la línea
// principal por _For/_ForUUID (mismo mecanismo que Gift Wrap / Box Engraving).
//
// Este bloque impone que NINGUNA de las dos líneas pueda existir sin la otra:
// - Si se elimina la línea principal, se elimina el cargo enlazado.
// - Si se elimina el cargo, se elimina la línea principal enlazada.
// Para detectar el segundo caso después de que el cargo ya no está en el
// carrito, se estampa properties._RequiresPersonalizationCharge = "true" en la
// línea principal en cuanto se detecta el cargo enlazado (no se puede saber,
// solo mirando el carrito post-eliminación, que esa línea alguna vez requirió
// el cargo si no queda esta marca).
// ---------------------------------------------------------------------------
(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof window.fetch !== 'function') return;

  var JSON_HEADERS = { 'Content-Type': 'application/json;charset=UTF-8' };
  var reconciling = false;
  var debounceTimer = null;

  function changeLine(key, payload) {
    var body = Object.assign({ id: key }, payload);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: JSON_HEADERS,
      credentials: 'same-origin',
      body: JSON.stringify(body)
    });
  }

  function reconcile() {
    if (reconciling) return;
    reconciling = true;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return null;

        var mainsByUUID = {};
        var charges = [];

        cart.items.forEach(function (item) {
          var p = item.properties || {};
          if (p._UUID) mainsByUUID[p._UUID] = item;
          if (p._PersonalizationCharge === 'true') charges.push(item);
        });

        var linkedMainUUIDs = {};
        var updates = [];

        charges.forEach(function (charge) {
          var p = charge.properties || {};
          var main = p._ForUUID ? mainsByUUID[p._ForUUID] : null;

          if (!main) {
            // El producto principal ya no está: eliminar el cargo huérfano.
            updates.push({ key: charge.key, payload: { quantity: 0 } });
            return;
          }

          linkedMainUUIDs[p._ForUUID] = true;

          if (main.properties._RequiresPersonalizationCharge !== 'true') {
            var stampedProperties = Object.assign({}, main.properties, {
              _RequiresPersonalizationCharge: 'true'
            });
            // IMPORTANTE: /cart/change.js resetea quantity a 1 si no se manda
            // explícitamente junto con properties (confirmado contra la API real).
            // Sin esto, un carrito con cantidad 3 se quedaba en 1 apenas se
            // estampaba la marca de vínculo.
            updates.push({ key: main.key, payload: { quantity: main.quantity, properties: stampedProperties } });
          }
        });

        Object.keys(mainsByUUID).forEach(function (uuid) {
          var main = mainsByUUID[uuid];
          if (main.properties._RequiresPersonalizationCharge === 'true' && !linkedMainUUIDs[uuid]) {
            // El cargo enlazado ya no está en el carrito: eliminar la línea principal.
            updates.push({ key: main.key, payload: { quantity: 0 } });
          }
        });

        if (!updates.length) return null;

        // Aplicar secuencialmente para no pisar el carrito entre llamadas.
        return updates.reduce(function (chain, u) {
          return chain.then(function () { return changeLine(u.key, u.payload); });
        }, Promise.resolve());
      })
      .catch(function (err) {
        console.error('[personalization-charge-link] error', err);
      })
      .then(function () { reconciling = false; });
  }

  function scheduleReconcile() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(reconcile, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleReconcile);
  } else {
    scheduleReconcile();
  }
  window.addEventListener('pageshow', scheduleReconcile);
  document.addEventListener('theme:cart:change', scheduleReconcile);

  var attachTries = 0;
  var attachInterval = setInterval(function () {
    var flyout = document.querySelector('.rebuy-cart__flyout, .rebuy-cart');
    if (flyout && !flyout.__personalizationChargeObserved) {
      flyout.__personalizationChargeObserved = true;
      new MutationObserver(scheduleReconcile).observe(flyout, {
        childList: true,
        subtree: true
      });
    }
    if (++attachTries > 20) clearInterval(attachInterval);
  }, 1000);
})();
